<template>
  <div class="ability-course">课程能力图谱</div>
</template>
<script>
export default {
  name: 'AbilityCourse',
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
.ability-course {
}
</style>